module.exports = __webpack_public_path__ + "img/Red.8546163d.png";